import React, {useMemo} from 'react';
import {InputSlider} from 'components';
import {suffixRemove} from 'utils';
import {useEditorStyle} from 'hooks';
import type {IChildrenProps} from './Editor.Inspector';

interface IEditorInspectorMarginProps extends IChildrenProps {}

const EditorInspectorMargin = ({style, setProp}: IEditorInspectorMarginProps) => {
  const values = useMemo(() => {
    const margins = style?.margin as string | undefined;
    const marginValues = margins ? margins.split(' ') : ['0', '0', '0', '0'];
    return marginValues.map(v => suffixRemove('px', v));
  }, [style?.margin]);

  const {updateStyle} = useEditorStyle({setProp});

  return (
    <div>
      <h4 className="font-medium text-sm text-slate-800 dark:text-white pb-4">Margin</h4>
      <div className="flex flex-col gap-3">
        {['Top', 'Right', 'Bottom', 'Left'].map((side, index) => {
          return (
            <InputSlider
              key={side}
              label={side}
              suffix="px"
              min={-100}
              defaultValue={values[index]}
              onSlide={value => {
                values[index] = value;
                updateStyle('margin', values.map(v => `${v}px`).join(' '));
              }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default React.memo(EditorInspectorMargin);
